import { UpdateTasksProvider } from "@/cv/queries/CvUpdateTasks.tsx";
import { ExtraInfoProvider } from "@/cv/queries/ExtraInfos.tsx";
import { registerAppProvider } from "@/shared/bootstrap/react.tsx";
import { SaveFailedProvider } from "@/shared/context/SaveFailed.tsx";

registerAppProvider(ExtraInfoProvider, UpdateTasksProvider, SaveFailedProvider);
